import { render, staticRenderFns } from "./cDialog.vue?vue&type=template&id=6312216f&scoped=true"
import script from "./cDialog.vue?vue&type=script&lang=js"
export * from "./cDialog.vue?vue&type=script&lang=js"
import style0 from "./cDialog.vue?vue&type=style&index=0&id=6312216f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6312216f",
  null
  
)

export default component.exports